import { Link } from 'react-router-dom';

type Props = {
	title: string;
	backTo: string;
	backLabel?: string;
};

export default function InsuranceLicenseFormHeader(props: Props) {
	const { title, backTo, backLabel = 'Back' } = props;

	return (
		<div className="insurance-license-form-header">
			<Link to={backTo} className="insurance-license-back-button">
				<span aria-hidden className="insurance-license-back-icon">
					&larr;
				</span>
				{backLabel}
			</Link>
			<h2>{title}</h2>
		</div>
	);
}
